import React from "react";
import { Pagination as Paginate, Select } from "@mantine/core";
const Pagination = ({
  setOffset,
  total,
  ItemPerPage,
  setItemPerPage,
  activePage,
  setPage,
}) => {
  const totalPages = ItemPerPage !== 0 ? Math.ceil(total / ItemPerPage) : 1;

  setOffset((activePage - 1) * ItemPerPage);

  return (
    <>
      <Paginate
        total={totalPages}
        page={activePage}
        onChange={setPage}
        color="yellow"
        radius="md"
        style={{
          marginRight: "5px",
        }}
      />
      {ItemPerPage >= 50 || ItemPerPage === 0 ? (
        <Select
          style={{
            width: "120px",
          }}
          placeholder="Item per page"
          value={ItemPerPage}
          onChange={(val) => {
            setItemPerPage(val);
            setPage(1);
          }}
          data={[
            { value: 50, label: "50" },
            { value: 100, label: "100" },
            { value: 200, label: "200" },
            { value: 500, label: "500" },
            { value: 1000, label: "1000" },
            { value: 0, label: "All" },
          ]}
        />
      ) : null}
    </>
  );
};

export default Pagination;
